<template>
  <div>
    <div class="document-container">
      <h1 class="fn-title-1 main-title">
        {{ document.type.name }}
      </h1>

      <div class="document-buttons">
        <button
          class="second-btn second-color documents-icon-button"
          @click="$emit('share')"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6L12 13L20 6M4 6H20M4 6V18H20V6" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 18L10 11.5M14 11.5L20 18" stroke="#001973" stroke-width="2"/>
          </svg>
        </button>

        <button
          class="second-btn second-color documents-icon-button"
          @click="print"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 15H4V9H20V15H17" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 9V5H17V9" stroke="#001973" stroke-width="2" stroke-linejoin="round"/>
            <rect x="7" y="13" width="10" height="6" stroke="#001973" stroke-width="2" stroke-linejoin="round"/>
          </svg>
        </button>

        <button
          class="second-btn second-color documents-icon-button"
          @click="$emit('download')"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 20H20" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 12L12 16L16 12" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4H13ZM13 16V4H11V16H13Z" fill="#001973"/>
          </svg>
        </button>

        <button
          class="second-color second-btn document-sign"
          @click="$emit('sign')"
        >
          Підписати
        </button>
      </div>

      <div
        class="document-viewer-background"
        @click="toggleFullscreen"
        :class="{ fullscreen: isFullscreen }"
        :style="iframeStyles"
      >
        <div
          class="document-viewer"
          v-if="documentUri"
          :class="{ fullscreen: isFullscreen }"
          :style="iframeStyles"
        >
          <iframe
            id="file"
            :src="documentUri"
            class="iframe"
            @load="resizeIframe"
            :style="iframeStyles"
          />

          <button
            class="second-btn second-color fullscreen-button"
            @click="toggleFullscreen"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 15V19H9" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19 9L19 5L15 5" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <hr class="hr" />

      <footer class="documents-footer">
        <button
          class="main-btn second-color document-sign"
          @click="$emit('sign')"
        >
          Підписати цей документ
        </button>

        <div class="documents-navigation">
          <button
            class="second-btn second-color documents-navigation-button"
            v-if="backward"
            @click="backward"
          >
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 1L1 7L7 13" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <button
            class="second-btn second-color documents-navigation-button"
            v-if="forward"
            @click="forward"
          >
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L1 13" stroke="#001973" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { printSignedPdf } from '../../util/printSignedPdf'

export default {
  name: 'DocumentsWorkspace',
  props: ['document', 'documentUri', 'forward', 'backward'],
  computed: {
    iframeStyles (vm) {
      const {
        frameHeight,
        frameWidth
      } = vm

      return {
        height: frameHeight && frameHeight > 150 ? frameHeight + 'px' : '100%',
        width: frameWidth ? frameWidth + 'px' : '100%'
      }
    }
  },
  methods: {
    async print () {
      try {
        const { document, documentUri } = this.$props

        await printSignedPdf(document, documentUri)
      } catch (e) {
        // this.$toastr('error', e.message)
        console.error(e.message)
        const frame = window.frames.file.contentWindow
        frame.focus()
        frame.print()
      }
    },
    resizeIframe () {
      const [content] = window.frames.file.contentWindow.document.body.children

      const {
        scrollWidth,
        scrollHeight
      } = content || {}

      this.frameHeight = scrollHeight
      this.frameWidth = scrollWidth
    },
    toggleFullscreen (e) {
      e.stopPropagation()
      this.isFullscreen = !this.isFullscreen
    }
  },
  data () {
    return {
      fileFrame: null,

      frameHeight: 0,
      frameWidth: 0,

      isFullscreen: false
    }
  }
}
</script>

<style lang="less" scoped>
.document-container {
  padding: 56px;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  align-items: center;
}
.main-title {
  display: block;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--grey-230);
}
.hr {
  margin: 56px 0;
  width: 100%;
  height: 1px;
  border: none;
  border-bottom: 1px solid var(--grey-230);
}
.document-buttons {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  width: 100%;
}
.documents-icon-button {
  padding: 8px;
  margin-right: 8px;
}
.document-sign {
  padding: 8px;
  color: var(--main-hover);
}
.document-viewer {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

height: 100%;
  overflow-x: auto;

  margin: auto;
}
.document-viewer-background {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  // pointer-events: none;

  &.fullscreen {
    pointer-events: all;
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw !important;
    min-height: 100vh !important;
    padding: 100px 0;
  }
}
.iframe {
  border: none;
  outline: none;
  flex-grow: 1;
  background: white;
}
.fullscreen-button {
  position: absolute;
  right: 16px;
  top: 16px;
  background: white;
  padding: 8px;
  z-index: 3;
}
.documents-navigation {
  display: flex;
}
.documents-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.documents-navigation-button {
  padding: 8px 14px;
  margin-left: 8px;
}

</style>
